import { useState } from 'react';

export const useLoadingBackdrop = () => {
    const [isLoading, setIsLoading] = useState(false);
    return { isLoading, setIsLoading };
};
